module.exports = __webpack_public_path__ + "static/media/icone-acoes-relatorio.744541fa.svg";